// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'check-polaris-solid';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m7.5 12.751 1.872 2.591c.216.36.72.432 1.08.216.071-.072.143-.144.215-.144L16.57 8M9.32 1.96v1.68m-.84-.84h1.68M3.04 8.36v1.68m-.8-.84h1.64' />
    <path
      fill='currentColor'
      d='M5.88 1.96c0 2.6 1.28 4.12 4.16 4.16-2.68 0-4.04 1.44-4.16 4.16-.04-2.56-1.16-4.16-4.16-4.16 2.68 0 4.16-1.32 4.16-4.16z'
    />
  </g>
);

export const viewBox = '0 0 18 18';
